import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Table } from 'reactstrap';
import { ActivityLogVM } from './ActivityLogVM';
import { formatDate } from 'cd-eft/utils/formatDate';
import { Pagination } from '../Pagination/Pagination';
import './ActivityLog.scss';

const ActivityLogComponent = (props) => {
  const vm = useRef(new ActivityLogVM(props)).current;

  useEffect(() => {
    vm.getActivityLog(props.projectId);
  }, [props.projectId, props.summaryUpdateVariable]);

  const start = (vm.pageNumber - 1) * vm.limitPerPage;
  const end = start + vm.limitPerPage;
  return (
    <>
      <div className="activity-log-header">
        <h3 className="activity-log">Project History</h3>
      </div>
      <div className="table-wrapper">
        <Table className="activity-table">
          <thead>
            <tr className="activity-header">
              <th className="header1">Author </th>
              <th className="header2">Project Status </th>
              <th className="header3">Action Type </th>
              <th className="header4">Action </th>
              <th className="header5">Modified By </th>
              <th className="header6">Date </th>
            </tr>
          </thead>
          <tbody>
            {vm.activityLog &&
              vm.activityLog.map((activity, i) => {
                return (
                  i >= start &&
                  i < end && (
                    <ActivityItem activity={activity} key={'key activity -' + i} data-testid={'activity-item-' + i} />
                  )
                );
              })}
          </tbody>
        </Table>
        {/* Pagination */}
        <div className="activity-pagination-container">
          <Pagination
            siblingCount={2}
            className="activity-pagination"
            currentPage={vm.pageNumber}
            totalCount={vm.activityLog.length}
            pageSize={vm.limitPerPage}
            onPageChange={(page) => vm.setCurrentPage(page)}
          />
        </div>
      </div>
    </>
  );
};
export const ActivityLog = observer(ActivityLogComponent);

const ActivityItem = (props) => {
  const { activity } = props;

  return (
    <tr className="log-details">
      <td>{activity.createdBy}</td>
      <td>{activity.projectStatus}</td>
      <td>{activity.crudCode}</td>
      <td>{activity.comment}</td>
      <td>{activity.lastChangedBy}</td>
      <td className="date">{formatDate(activity.lastChangeDateUtc)}</td>
    </tr>
  );
};
